import React from 'react';

const ProductOptionComponent = ({ data, innerProps, isFocused, isSelected, showStock = false }) => {
    const product = data.product;
    
    // Debug: Log the product data to see what we're getting
    console.log('ProductOptionComponent - product:', product);
    console.log('ProductOptionComponent - product.code:', product.code, 'type:', typeof product.code);
    
    // Handle cases where code might be null, undefined, or 0
    const code = product.code && product.code > 0 ? product.code : '';

    const handleAvailabilityClick = (e) => {
        e.stopPropagation();
        if (data.onAvailabilityClick) {
            data.onAvailabilityClick(product);
        }
    };
    
    return (
        <div
            {...innerProps}
            data-test={`product-async-option`}
            style={{
                display: 'flex',
                alignItems: 'center',
                backgroundColor: isSelected ? '#007bff' : isFocused ? '#f8f9fa' : 'white',
                color: isSelected ? 'white' : 'black',
                cursor: 'pointer',
                borderBottom: '1px solid #eee',
                width: '100%'
            }}
        >
            <div style={{ 
                display: 'flex', 
                width: '100%',
                fontSize: '14px',
                alignItems: 'center'
            }}>
                <div style={{
                    textAlign: 'center',
                    width: '50px',
                    fontWeight: 'bold',
                }}>
                    {code}
                </div>
                <div style={{
                    maxWidth: '200px',
                    flex: 1,
                    textAlign: 'left',
                }}>
                    {product.name}
                </div>
                {showStock && (<div style={{
                    width: '60px',
                    textAlign: 'center',
                }}>
                    {product.stock}
                </div>)}
                <div style={{ 
                    width: '50px',
                    textAlign: 'center'
                }}>
                    {data.showProductAvailability &&( <button
                        style={{
                            fontSize: '12px',
                            padding: '4px 8px',
                            backgroundColor: isSelected ? 'white' : '#007bff',
                            color: isSelected ? '#007bff' : 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                        onClick={handleAvailabilityClick}
                        data-test={`product-availability-button-${product.id}`}
                    >
                        Disponibilidade
                    </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProductOptionComponent; 